/**
 * captureDeleteConfirm — confirm-dialog copy for deleting a SINGLE capture.
 *
 * ISP-9999 — "Delete capture? This capture will be permanently removed from
 * your inbox." never named the target, so a user with two similar captures
 * open had no way to tell which one they were about to destroy. Names it the
 * same way the bulk delete confirm already names its selection
 * (captureBulkConfirm.bulkDeleteConfirmCopy) — via captureDisplayName,
 * truncated so one long title can't swallow the dialog.
 */
import { captureDisplayName } from "./captureDisplayName";

/** How much of the name to show before truncating with an ellipsis. */
const MAX_NAME_LENGTH = 40;

const shorten = (name, max = MAX_NAME_LENGTH) =>
  name.length > max ? `${name.slice(0, max - 1).trimEnd()}…` : name;

/**
 * @param {object} item the capture row about to be deleted
 * @returns {{title: string, subtitle: string}}
 */
export const deleteConfirmCopy = (item) => ({
  title: `Delete “${shorten(captureDisplayName(item))}”?`,
  subtitle: "This capture will be permanently removed from your inbox.",
});
